import React from "react";
import { connect } from "react-redux";
import { Form, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";
import { PhoneInput } from "react-international-phone";
import 'react-international-phone/style.css'

import Address from "../../../layout/address";
import ConditionalButton from "../../../layout/conditional-button";
import ErrorModal from "../../../layout/modal";

import { isGuid } from "../../../utils/string";
import { withNavigation } from "../../../utils/wrapper";

import { send as pageInfo, loading } from "../../../actions/page";
import { get as getCourt, save as saveCourt } from "../../../actions/courts";
import { send as sendAlert } from "../../../actions/alert";

class Detail extends React.Component {
    
    constructor(props) {
        super(props);
        this.props.loading(true);
        this.state = {
            modal: {
                error: {
                    show: false
                }
            }
        };
        this.defaultCountry = "us";
        this.props.pageInfo({ title: "Court", breadcrumb: `[New Court]` });
        this.changes = {};   
        this.query = new URLSearchParams(window.location.search);
    }

    get uuid() {
        return this.props.params.uuid;
    }

    loadData = async () => {
        this.props.loading(true);
        try {
            const from = this.query.get("from");
            const loadFrom = isGuid(this.uuid) ? this.uuid : isGuid(from) ? from : null;
            const cloned = isGuid(from);

            if (!loadFrom) return;

            const court = await this.props.getCourt({ uuid: loadFrom });
            if (!court) return;

            if (cloned) {
                const clonedAddressUuid = uuidv4();
                court.uuid = uuidv4();
                court.Address = {
                    ...(court.Address || {}),
                    uuid: clonedAddressUuid
                };
                court.addressUuid = clonedAddressUuid;
                court.full = `${court.full || ""} (clone)`;
            }

            this.setState(court);
            await this.props.pageInfo({
                title: `Court (${court.full || "..."})`,
                breadcrumb: `${court.full || "Court"}`
            });
        } finally {
            this.props.loading(false);
        }
    };

    componentDidMount = async () => {
        await this.loadData();
    }

    doCallChange = () => {
        if (this.props.onChange) this.props.onChange({ ...this.state });
    }

    
    onChange = (e) => {
        this.setState(
            { [e.target.name]: e.target.value },
            this.doCallChange
        );
    };

    onAddressChange = (objectName, values) => {
        const nextAddressUuid = values?.uuid || this.state.addressUuid || uuidv4();

        this.setState({
            addressUuid: nextAddressUuid,
            [objectName]: {
                ...values,
                uuid: nextAddressUuid
            }
        }, this.doCallChange);
    };

    validate = () => {
        const errors = {};
        const name = (this.state.name || "").trim();
        const citation = (this.state.citation || "").trim();
        const full = (this.state.full || "").trim();

        if (!name) errors.name = "Court name is required.";
        if (!citation) errors.citation = "Court citation is required.";
        if (!full) errors.full = "Court description is required.";

        return {
            isValid: Object.keys(errors).length === 0,
            errors
        };
    }

    isSaveEnabled = () => {
        const { isValid } = this.validate();
        return isValid;
    }

    onSaveClick = async () => {
        const { isValid, errors } = this.validate();
        if (!isValid) {
            if (errors.name) this.props.sendAlert(errors.name, "error");
            if (errors.citation) this.props.sendAlert(errors.citation, "error");
            if (errors.full) this.props.sendAlert(errors.full, "error");
            return;
        }

        this.props.loading(true);
        try {
            const {
                uuid,
                parentUuid,
                name,
                citation,
                full,
                district,
                division,
                url,
                email,
                phone,
                chambers,
                fax,
                addressUuid,
                Address,
                pacer
            } = this.state;

            const nextCourtUuid = isGuid(this.uuid) ? this.uuid : (uuid || uuidv4());
            const nextAddressUuid = addressUuid || Address?.uuid || uuidv4();

            const court = await this.props.saveCourt({
                uuid: nextCourtUuid,
                parentUuid,
                name: name.trim(),
                citation: citation.trim(),
                full: full.trim(),
                district,
                division,
                url,
                email,
                phone,
                chambers,
                fax,
                addressUuid: nextAddressUuid,
                Address: Address ? { ...Address, uuid: nextAddressUuid } : null,
                pacer
            });

            window.location.href = `/dashboard/courts/${court?.uuid}`;
        } catch (err) {
            this.props.sendAlert(err?.message || "Unable to save court.", "error");
        } finally {
            this.props.loading(false);
        }
    };

    onCloneClick = () => {
        window.location.href = `/dashboard/courts/add?from=${this.uuid}`;
    }

    onErrorHideModal = (e) => {
        this.setState(prev => ({
            modal: {
                ...prev.modal,
                error: {
                    show: false
                }
            }
        }))
    }


    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Clone Court" display={isGuid(this.uuid)} enabled={true} onEnabledClick={this.onCloneClick} icon="duplicate">Clone</ConditionalButton>
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Save Court" display={true} enabled={true} onEnabledClick={this.onSaveClick} icon="save">Save</ConditionalButton>
                </Col>
                
                <Col xs="12">
                    <Row>
                        <Col lg="12">
                            <Row className="g-3">
                                <Col lg="12">
                                    <h2 className="small-title">Court Information</h2>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col xs="12" md="8">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="name" value={this.state.name || ""} onChange={this.onChange} />
                                        <Form.Label>NAME</Form.Label>
                                    </div>
                                </Col>
                                <Col xs="12" md="4">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="citation" value={this.state.citation || ""} onChange={this.onChange} />
                                        <Form.Label>CITATION</Form.Label>
                                    </div>
                                </Col>
                                <Col xs="12">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="full" value={this.state.full || ""} onChange={this.onChange} />
                                        <Form.Label>DESCRIPTION</Form.Label>
                                    </div>
                                </Col>
                                <Col xs="12" md="6">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="district" value={this.state.district || ""} onChange={this.onChange} />
                                        <Form.Label>DISTRICT</Form.Label>
                                    </div>
                                </Col>
                                <Col xs="12" md="6">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="division" value={this.state.division || ""} onChange={this.onChange} />
                                        <Form.Label>DIVISION</Form.Label>
                                    </div>
                                </Col>
                                <Col xs="12">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="url" value={this.state.url || ""} onChange={this.onChange} />
                                        <Form.Label>URL</Form.Label>
                                    </div>
                                </Col>
                                <Col xs="12">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="email" value={this.state.email || ""} onChange={this.onChange} />
                                        <Form.Label>EMAIL ADDRESS</Form.Label>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="g-3">
                                <Col md="6" lg="4" xxl="3"><h2 className="small-title">Phone #</h2>
                                    <div className="mb-3">
                                        <PhoneInput name="phone" id="phone" defaultCountry={this.defaultCountry} value={this.state.phone || ""} onChange={(value) => this.onChange({
                                            target: {
                                                name: "phone",
                                                value
                                            }
                                        })} />
                                    </div>
                                </Col>
                                <Col md="6" lg="4" xxl="3"><h2 className="small-title">Chambers #</h2>
                                    <div className="mb-3">
                                        <PhoneInput name="chambers" id="chambers" defaultCountry={this.defaultCountry} value={this.state.chambers || ""} onChange={(value) => this.onChange({
                                            target: {
                                                name: "chambers",
                                                value
                                            }
                                        })} />
                                    </div>
                                </Col>
                                <Col md="6" lg="4" xxl="3"><h2 className="small-title">Fax #</h2>
                                    <div className="mb-3 top-label">
                                        <PhoneInput name="fax" id="fax" defaultCountry={this.defaultCountry} value={this.state.fax || ""} onChange={(value) => this.onChange({
                                            target: {
                                                name: "fax",
                                                value
                                            }
                                        })} />
                                    </div>
                                </Col>
                            </Row>
                
                        </Col>
                    </Row>
                    <Row className="g-3">
                        <Col lg="12">
                            <h2 className="small-title">Address</h2>
                        </Col>
                    </Row>
                
                    <Address {...this.state?.Address} onChange={(values) => this.onAddressChange("Address", values)} />
                </Col>
                <ErrorModal show={this.state.modal.error.show} title={this.state.modal.error.title} body={this.state.modal.error.body} buttons={
                    [
                        {
                            default: true,
                            caption: "ok",
                            onEnabledClick: this.onErrorHideModal,
                            variant: "secondary",
                            enabled: true,
                            display: true
                        }
                    ]
                }></ErrorModal>
            </>
        );
    }
};

Detail.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default withNavigation(connect(mapStateToProps, { pageInfo, loading, getCourt, saveCourt, sendAlert })(Detail));
